const styles = {
  global: {
    html: {
      background: '#FAFAFA',
    },
  },
};

export default styles;
